module.exports = __webpack_public_path__ + "img/icon_shexiangtouzaixian.ab688840.png";